import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AccountRequestService } from '../../auth/service/account-request.service';
import { WorkflowsService } from '../../system/workflows/service/workflows.service';
import { NodesService } from '../service/nodes.service';

@Component({
    selector: 'app-node-document',
    templateUrl: './node-document.component.html',
    styleUrl: './node-document.component.scss'
})
export class NodeDocumentComponent implements OnInit {
    constructor(
        private nodeService: NodesService,
        private accountRequestService: AccountRequestService,
        private workflowsService: WorkflowsService,
        private router: Router,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }
}
